import $ from "jquery";
export function setButtonStatus(experienceLenght, activeProfessionalExperience) {
	$('#professionalExperience .prev').prop('disabled', activeProfessionalExperience === 0);
	$('#professionalExperience .next').prop('disabled', activeProfessionalExperience === experienceLenght - 1);
}